const MAX_LENGTH = 20;
const RANDOM_ID_LENGTH = 6;
const RANDOM_ALPHABET = 'abcdefghijklmnopqrstuvwxyz0123456789';

const generateRandomId = () => {
  if (typeof crypto !== 'undefined' && typeof crypto.getRandomValues === 'function') {
    const buffer = new Uint8Array(RANDOM_ID_LENGTH);
    crypto.getRandomValues(buffer);
    return Array.from(buffer, (byte) => RANDOM_ALPHABET[byte % RANDOM_ALPHABET.length]).join('');
  }

  return Array.from({ length: RANDOM_ID_LENGTH }, () =>
    RANDOM_ALPHABET[Math.floor(Math.random() * RANDOM_ALPHABET.length)]
  ).join('');
};

export const generateSubdomainFromAppName = (appName?: string): string => {
  if (!appName) return '';

  let slug = appName.toLowerCase().replace(/[^a-z0-9]/g, '');

  if (!slug) slug = 'aaa';

  const maxBaseLength = Math.max(1, MAX_LENGTH - RANDOM_ID_LENGTH - 1);
  if (slug.length < 3) slug = slug.padEnd(3, 'a');
  if (slug.length > maxBaseLength) slug = slug.slice(0, maxBaseLength);

  const randomId = generateRandomId();
  return `${slug}-${randomId}`;
};